export default __webpack_public_path__ + "static/media/ola.bf77294f.jpg";